export const CATEGORY_CONFIG = {
	Fashion: {
		subCategory: [
			"Men",
			"Women",
			"Kids",
			"Footwear",
			"Accessories",
			"Bags ",
		],
		showMinOrder: true,
	},

	Food: {
		subCategory: ["Restaurant", "Cafe", "Bakery"],
		offerType: [
			"Percentage",
			"Flat",
			"BOGO",
			"Buy1 Get1",
			"Buy2 Get1",
			"Combo",
		],
		showMinOrder: true,
	},
	Electronics: {
		subCategory: [
			"Mobiles",
			"Laptops",
			"Home Appliances",
			"Wearables",
			"Audio Devices",
		],
		showMinOrder: true,
	},
	Salon: {
		fields: ["serviceType"],
		subCategory: [],
		showMinOrder: true,
	},
	"Beauty Product": {
		subCategory: ["Skincare", "Makeup", "Haircare", "Nail Art"],
		showMinOrder: true,
	},
};
